import type { MemberRole } from './types';

/** Who an access rule applies to: a team, or a WORKSPACE role (standard or custom). */
export type Principal =
  | { kind: 'team'; id: string }
  | { kind: 'role'; role: MemberRole }
  | { kind: 'custom_role'; id: string };

export type PrincipalType = 'team' | 'workspace_role';

export function principalValue(principal: Principal | null): string | null {
  if (!principal) return null;
  if (principal.kind === 'team') return `team:${principal.id}`;
  if (principal.kind === 'role') return `role:${principal.role}`;
  return `custom:${principal.id}`;
}

export function parsePrincipal(value: string): Principal | null {
  const [prefix, ...rest] = value.split(':');
  const id = rest.join(':');
  if (prefix === 'team' && id) return { kind: 'team', id };
  if (prefix === 'role' && id) return { kind: 'role', role: id as MemberRole };
  if (prefix === 'custom' && id) return { kind: 'custom_role', id };
  return null;
}
